// React
import React, { useRef, useState } from 'react';
// Mantine
import { Button, Flex, Group, Modal, Text } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { MRT_TableInstance } from 'mantine-react-table';

// Icons
import { IconUpload } from '@tabler/icons-react';
// Interfaces
import { EOB } from 'interfaces';
import { UploadButton } from 'components/common/UploadButton';

interface EOBUploadFileButtonProps {
  table: MRT_TableInstance<EOB>;
  handleSubmitFile: () => void;
  eobFile: File | null;
  setEobFile: React.Dispatch<React.SetStateAction<File | null>>;
}

export const UploadFileButton = ({
  table,
  handleSubmitFile,
  eobFile,
  setEobFile,
}: EOBUploadFileButtonProps) => {
  const [modal, setModal] = useState(false);
  const openRef = useRef<() => void>(null);

  return (
    <>
      <UploadButton
        onClick={() => {
          setModal(true);
          table.setEditingRow(null);
        }}
      />
      <Modal
        opened={modal}
        onClose={() => {
          setEobFile(null);
          setModal(false);
        }}
        title="Upload EOB File"
        size={'lg'}
      >
        <Group justify="center" style={{ width: '100%' }}>
          <Dropzone
            openRef={openRef}
            activateOnClick={true}
            multiple={false}
            accept={['application/pdf', 'text/plain']}
            onDrop={(file) => {
              setEobFile(file[0]);
            }}
          >
            <Text>EOB File</Text>
            <Group
              justify="center"
              gap="xl"
              style={{
                minHeight: 220,
                minWidth: 220,
                pointerEvents: 'none',
              }}
            >
              <Dropzone.Idle>
                <IconUpload size="3.2rem" stroke={1.5} />
              </Dropzone.Idle>
              {eobFile && (
                <Text size="md" inline ta="center">
                  {eobFile?.name}
                </Text>
              )}
            </Group>
          </Dropzone>
        </Group>
        <Flex justify="center" mt="lg">
          <Button
            onClick={() => {
              handleSubmitFile();
              setModal(false);
            }}
          >
            Submit
          </Button>
        </Flex>
      </Modal>
    </>
  );
};
